import { HttpErrorResponse } from "./http-error-response";

export class HttpResponse {
  error?: HttpErrorResponse;

  get isSuccess(): boolean {
    return !this.error;
  }
}
